/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommonErrorDef } from './commonErrorDef';
import { CommonInfo } from './commonInfo';


export interface CommonData { 
    errors?: Array<CommonErrorDef>;
    info?: CommonInfo;
    warnings?: Array<CommonErrorDef>;
}

